import { Context, ExtraContext } from '@utilitywarehouse/tracking-core';

import { TrackingContextName } from '@src/types/tracking';

const findTrackingContextIndex = (
  contexts: ExtraContext<Context>[],
  contextName: TrackingContextName
): number => {
  return contexts.findIndex(({ name }) => name === contextName);
};

export { findTrackingContextIndex };
